import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <path d="M 4 2 L 4 22 L 6 22 L 6 14.21875 C 6.617188 13.675781 7 12.886719 7 12 C 7 11.113281 6.617188 10.324219 6 9.78125 L 6 2 Z M 20 2 C 14.464844 2 10 6.464844 10 12 C 10 17.535156 14.464844 22 20 22 L 20 20 C 15.535156 20 12 16.464844 12 12 C 12 7.535156 15.535156 4 20 4 Z M 20 6 C 16.675781 6 14 8.675781 14 12 C 14 15.324219 16.675781 18 20 18 L 20 16 C 17.722656 16 16 14.277344 16 12 C 16 9.722656 17.722656 8 20 8 Z M 20 10 C 18.898438 10 18 10.898438 18 12 C 18 13.101563 18.898438 14 20 14 Z" />,
  'InfraredSensorOutlined'
);
